export const AmenityGrouping = {
  rate: {
    breakfast: [2, 22, 23, 24, 25, 26, 65, 70, 71, 72, 73, 74],
    lunch: [27],
    dinner: [28, 29, 30, 31, 32, 33],
    full_board: [58, 69],
    half_board: [67, 75],
  },
};
